"use strict";

var CHARSET =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// NB: does not validate input
export const idCompress = (hex?: string) => {
  return hex ?? "";
  /* if (typeof hex !== "string" || hex.length !== 24) {
    return hex;
  }
  return parseInt(hex, 16).toString(32); */
};

export const idDecompress = (str?: string) => {
  return str;
  /*if (typeof str !== "string") {
    return str;
  }

  return parseInt(str, 32).toString(16); */
};
